import { View } from '@react-pdf/renderer'
import { Objectclass, YesObject } from '@yes.technology/react-toolkit'
import { ConcatFields } from 'shared/utils/object/concatenateFields'
import PDFAreaLine from '../PDFAreaLine'
import PDFDataTable from '../PDFDataTable/PDFDataTable'

interface DataTablesAreaProps {
  objectclass: Objectclass
  objects: YesObject[]
  columns: string[]
  concatFields?: ConcatFields
  showHeader?: boolean
}

const DEFAULT_ITEMS_PER_PAGE = 10

function DataTablesArea({
  objectclass,
  objects,
  columns,
  concatFields,
  showHeader
}: DataTablesAreaProps) {
  return (
    <View>
      {showHeader && <PDFAreaLine title={objectclass.des} />}

      <PDFDataTable
        objects={objects}
        fields={objectclass.fields}
        columns={columns}
        itemsPerPage={DEFAULT_ITEMS_PER_PAGE}
        concatFields={concatFields}
      />
    </View>
  )
}

export default DataTablesArea
